import { Button, Col, Container, Image, Row, Tab, Tabs } from "react-bootstrap";
import carrersImg from "../../../Assets/Images/Careers/Careers.png";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
  textLightColor,
} from "../../../Constants/Colors";
import { LuArrowUpRight } from "react-icons/lu";
import "./Careers.css";
import { brandLogo, brandName } from "../../../Constants/content";
import { GoArrowUpRight } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import carrersExploreImg from "../../../Assets/Images/Careers/carrerExplore.jpg";
import {
  useGetJobsQuery,
  useGetJobCategoriesQuery,
} from "../../../redux/api/CareersApi/careersApi";
import { useGetSettingsQuery } from "../../../redux/api/SettingsApi/settingsApi";
import LoaderSpinner from "../../../Components/LoaderSpinner";
import SEO from "../../../Components/SEO";

const Careers = () => {
  const navigate = useNavigate();
  const { data: settings } = useGetSettingsQuery();
  const radius = 60;
  const { data: jobs, isLoading: isJobsLoading } = useGetJobsQuery({
    status: true,
  });
  const { data: fetchedCategories, isLoading: isCatsLoading } =
    useGetJobCategoriesQuery();

  const careersDescription = `At ${brandName}, we foster an environment of collaboration, creativity, and continuous growth. Join us to build impactful digital products and grow with a team that values your ideas.`;

  const activeCategories = fetchedCategories?.filter((c) => c.status) || [];

  // Use active categories or fallback if still loading/empty
  const categoriesToDisplay =
    activeCategories.length > 0
      ? activeCategories.map((c) => ({ eventKey: c.slug, title: c.name }))
      : [
          { eventKey: "design", title: "Design" },
          { eventKey: "development", title: "Development" },
          { eventKey: "marketing", title: "Marketing" },
          { eventKey: "others", title: "Others" },
        ];

  const isLoading = isJobsLoading || isCatsLoading;

  const whyJoinUs = [
    {
      title: "Friendly Work Culture",
      description:
        "We foster a collaborative, respectful, and positive workspace that feels like a second home.",
    },
    {
      title: "Continuous Learning",
      description:
        "We invest in your growth through regular workshops, mentorship, and hands-on project experience.",
    },
    {
      title: "Recognition that Matters",
      description:
        "Your contributions won’t go unnoticed. We celebrate wins — big or small — and reward impact.",
    },
    {
      title: "Team Bonding & Fun",
      description:
        "From office celebrations to team outings and friendly games — we make workdays more fun.",
    },
  ];

  return (
    <>
      <SEO
        title="Careers | Join Our Team at Ideal Corporate Services"
        description={settings?.meta_description}
        keywords={settings?.meta_keyword}
      />
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={6}
            className="m-auto d-flex flex-column justify-content-center"
          >
            <div
              style={{
                textAlign: "center",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#009dff",
                  border: "none",
                  boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                }}
                className="rounded-pill my-2 px-4"
              >
                Careers
              </Button>

              <h1
                className="my-3"
                style={{ color: "#009dff", fontWeight: "bold" }}
              >
                Build the Future With Us
              </h1>

              <p className="text-muted mb-4">{careersDescription}</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Image src={carrersImg} fluid />
          </Col>
        </Row>

        <Row>
          <h1 className="my-5 text-center">
            Shape the <span style={{ color: primaryColor }}>Future</span> With{" "}
            <span style={{ color: primaryColor }}>Your Skills</span>{" "}
          </h1>

          <Tabs
            defaultActiveKey="design"
            id="fill-tab-example"
            className="mb-3 careers-tabs"
          >
            {categoriesToDisplay.map((career, index) => {
              const filteredJobs =
                jobs?.filter(
                  (job) =>
                    (job.category_id
                      ? job.jobCategory?.slug === career.eventKey
                      : job.category?.toLowerCase() === career.eventKey) &&
                    job.status,
                ) || [];

              return (
                <Tab
                  eventKey={career.eventKey}
                  title={career.title}
                  key={index}
                >
                  {isLoading ? (
                    <div className="text-center py-5">
                      <LoaderSpinner />
                    </div>
                  ) : filteredJobs.length > 0 ? (
                    filteredJobs.map((job, jobIndex) => (
                      <Row
                        key={jobIndex}
                        style={{
                          border: `2px solid #819A91`,
                          borderRadius: "15px",
                          width: "80%",
                        }}
                        className="my-4 m-auto"
                      >
                        <Col
                          xs={12}
                          md={8}
                          lg={9}
                          className="py-2 px-2 py-md-3 px-md-4"
                        >
                          <h6
                            style={{ color: primaryColor }}
                            className="fw-bold"
                          >
                            {job.title}
                          </h6>
                          <h5 className="fw-bold">
                            {job.jobType || "Full time"}
                          </h5>
                          <p className="text-truncate-2">
                            {job.roleDescription}
                          </p>
                          <Link
                            to={`/careers/${job.slug}`}
                            style={{ color: primaryColor }}
                            className="arrowLauncher-container"
                          >
                            Learn more{" "}
                            <LuArrowUpRight className="fs-5 arrowLauncher" />
                          </Link>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-center">
                          <Button
                            onClick={() => navigate(`/careers/${job.slug}`)}
                            style={{
                              backgroundColor: secondaryColor,
                              color: textDarkColor,
                              border: "none",
                              boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                            }}
                            className="rounded-pill my-2 px-4 arrowLauncher-container"
                          >
                            Apply Now{" "}
                            <LuArrowUpRight className="fs-5 arrowLauncher" />
                          </Button>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <Row className="text-center py-5">
                      <Col
                        xs={12}
                        md={10}
                        className="alert alert-warning m-auto"
                        role="alert"
                      >
                        <h5 className="alert-heading">
                          No Positions Available
                        </h5>
                        <p className="mb-0">
                          There are currently no open positions in this
                          category. Please check back later or explore other
                          career opportunities.
                        </p>
                      </Col>
                    </Row>
                  )}
                </Tab>
              );
            })}
          </Tabs>
        </Row>

        <h1 style={{ color: primaryColor }} className="text-center">
          Why should you join us?
        </h1>
        <Row className="my-4">
          <Col xs={12} md={11} className="m-auto">
            <p className="text-justify">
              At {brandName}, every team member is seen, heard, and empowered.
              We believe in creating a workplace where your work matters, your
              ideas are valued, and your growth is a shared goal. Here, you're
              not just part of a team — you're part of something meaningful.
            </p>
          </Col>
        </Row>

        <Row className="d-flex justify-content-around">
          {whyJoinUs.map((item, index) => (
            <Col
              key={index}
              xs={11}
              md={4}
              style={{
                border: `3px solid ${primaryColor}`,
                borderRadius: "20px",
              }}
              className="px-3 py-5 mb-5 mx-lg-4 mx-0"
            >
              <h5 className="barTop position-relative mb-4">{item.title}</h5>
              <p className="text-justify mb-0">{item.description}</p>
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12} md={10} className="m-auto mb-5">
            <div
              style={{
                padding: "2px",
                borderRadius: "20px",
                background: `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`,
              }}
            >
              <Row
                className="align-items-center p-2 p-md-1 m-auto justify-content-center py-3"
                style={{
                  backgroundColor: "#c6e0f7",
                  borderRadius: "18px",
                }}
              >
                <Col
                  xs={3}
                  className="d-flex justify-content-center align-items-center"
                >
                  <Image
                    src={brandLogo}
                    style={{ width: "120px", height: "80px" }}
                  />
                </Col>
                <Col md={6} className="text-start py-3">
                  <h5>
                    Didn’t find the role you’re looking for? Let’s still
                    connect.
                  </h5>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Send your resume + portfolio to hr@idealcorp.in
                  </p>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Subject: [Your Role] – [Your Name]
                  </p>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Or Hit &nbsp;&nbsp;
                    <a
                      href={"#fill-tab-example"}
                      style={{ color: textDarkColor }}
                      className="arrowLauncher-container"
                    >
                      Apply Now{" "}
                      <LuArrowUpRight className="fs-5 arrowLauncher" />
                    </a>
                  </p>
                </Col>
                <Col md={3} className="text-end mt-3 mt-md-0">
                  <div
                    style={{
                      position: "relative",
                      width: radius * 2 + 40,
                      height: radius * 2 + 40,
                      margin: "auto",
                    }}
                  >
                    {/* Static Center Icon */}
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                      }}
                      className="arrowLauncher-container"
                    >
                      <GoArrowUpRight
                        size={38}
                        color={textDarkColor}
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/careers")}
                        className="arrowLauncher"
                      />
                    </div>

                    {/* Rotating SVG Circle with Text */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        animation: "spin 10s linear infinite",
                        zIndex: 1,
                      }}
                    >
                      <svg width="100%" height="100%" viewBox="0 0 250 250">
                        <defs>
                          <path
                            id="circlePath"
                            d={`
                                     M 125,125
                                     m -${radius},0
                                     a ${radius},${radius} 0 1,1 ${radius * 2},0
                                     a ${radius},${radius} 0 1,1 -${
                                       radius * 2
                                     },0
                                   `}
                          />
                        </defs>
                        <text
                          fill={textDarkColor}
                          fontSize="20"
                          fontFamily="sans-serif"
                        >
                          <textPath href="#circlePath" startOffset="0%">
                            Get in touch • Hire us • Contact us • Connect with
                            us •
                          </textPath>
                        </text>
                      </svg>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row
          className="d-flex justify-content-center align-items-center careers-background mb-5"
          style={{
            backgroundImage: `url(${carrersExploreImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Col
            xs={12}
            md={8}
            className="text-center d-flex flex-column align-items-center"
          >
            <h1 style={{ color: textLightColor }}>
              The future is built by people who care. Let’s design it together.
            </h1>
            <Button
              style={{
                backgroundColor: secondaryColor,
                color: textDarkColor,
                border: "none",
                boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
              }}
              className="rounded-pill my-2 px-4 arrowLauncher-container"
            >
              Apply Now <LuArrowUpRight className="fs-5 arrowLauncher" />
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Careers;
